import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import { drawer } from '@/store/stateless/drawer';
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'LandingView',
  setup(__props) {

const goHome = () => {
  router.push({ name: 'Home' });
};

return (_ctx: any,_cache: any) => {
  const _component_etc_drawer = _resolveComponent("etc-drawer")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { id: "inspire" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_navigation_drawer, {
        modelValue: _unref(drawer).open,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(drawer).open) = $event)),
        app: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_etc_drawer)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_app_bar, { class: "header-nav" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_nav_icon, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(drawer).open = !_unref(drawer).open))
          }),
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                onClick: goHome,
                src: require('@/assets/logo-no-padding.png'),
                width: "140",
                alt: "Logo of company",
                style: {"cursor":"pointer"}
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})